import { createSelector } from "reselect";
import { ConnectionStatus } from "@evergis/api";
import { SpState } from "./sp";
import { RootState } from "../reducers";

const connectionOkStatuses: SpState[] = [ConnectionStatus.Connected, ConnectionStatus.Initialized];

export const connectionStatus = ({ sp }: RootState) => sp;

export const hasConnectionProblem = createSelector(connectionStatus, status => !connectionOkStatuses.includes(status));
